module.exports = __webpack_public_path__ + "static/benski_logo_light-f88f9ea023328a94865a6201f27b5ea4.png";